import { useNavigate } from 'react-router-dom'
import { useTheme } from '@/store/useTheme'
import styles from './LandingPage.module.css'

const OPTIONS = [
  {
    id: 'practitioner',
    label: 'Practitioner',
    subtitle: 'Sign in to your practice',
    path: '/login',
  },
  {
    id: 'client',
    label: 'Client',
    subtitle: 'Your Space and your sessions',
    path: '/client-login',
  },
] as const

export default function LandingPage() {
  const navigate = useNavigate()
  const { palette } = useTheme()

  const paletteVars = {
    '--lp-bg':   palette.bg,
    '--lp-text': palette.text,
    '--lp-ring': palette.ring,
  } as React.CSSProperties

  return (
    <main className={styles.page} style={paletteVars} aria-label="FitUTogether home">
      <div className={styles.inner}>
        <h1 className={styles.heading}>FitUTogether</h1>

        <div className={styles.options} role="group" aria-label="Choose how to continue">
          {OPTIONS.map(opt => (
            <button
              key={opt.id}
              type="button"
              className={styles.optionCard}
              onClick={() => navigate(opt.path)}
            >
              <span className={styles.optionLabel}>{opt.label}</span>
              <span className={styles.optionSub}>{opt.subtitle}</span>
            </button>
          ))}
        </div>
      </div>
    </main>
  )
}
